export const BENEFITS = `
  query benefits(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $filter: FilterBenefitInput
    $searchText: String
  ) {
    benefits(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Benefit {
        id
        name
        company_number
        monthly_fee_discount
        signup_discount
        active
        description
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const BENEFITS_BY_COMPANY_NUMBER = `
  query benefitsByCompanyNumber($company_number: Int!, $tenant_id: Int!) {
    benefitsByCompanyNumber(company_number: $company_number, tenant_id: $tenant_id) {
      __typename
      ... on Benefit {
        id
        name
        company_number
        monthly_fee_discount
        signup_discount
        active
        description
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const APPLICABLE_BENEFITS = `
  query applicableBenefits($tenant_id: Int!, $input: ApplicableBenefitsInput!) {
    applicableBenefits(tenant_id: $tenant_id, input: $input) {
      __typename
      ... on Benefit {
        id
        name
        company_number
        monthly_fee_discount
        signup_discount
        active
        description
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CALCULATE_BENEFIT_FEES = `
  query calculateBenefitFees($tenant_id: Int!, $input: CalculateFeeInput!) {
    calculateBenefitFees(tenant_id: $tenant_id, input: $input) {
      monthly_fee
      signup_fee
      monthly_fee_discount
      signup_discount
    }
  }
`;
